export default __webpack_public_path__ + "static/media/Raleway-VariableFont_wght.942638e6.ttf";